const state = require('./state.js');
const ui = require('../ui');
const offer = require('../offer');
const DOM = require('./dom.js');
const { useDropdown, useDisableSpace, useDisabled, useCalendar, useFocus, useVisibility, useValidation, useTooltip, useKeys } = require('../common.js');
const moment = require('moment');
const { getField } = require('../helpers.js');
const vehicleState = require('../vehicle/state.js');

let initialized = false;
export const init = async () => {
    if (initialized) return;

    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;

    try {
        ui.state.isLoading = false;
        initialized = true;
        setTimeout(() => {
            DOM.txtInsuredCNP.focus();
        }, 600);
        
        if (!state.postalCodeResponse) {
            await findPostalCode('010');
            state.cityName = null;
            state.street = null;
            ddlPostcode.state.focused = false;
            txtCity.state.focused = false;
            txtCity.state.disabled = false;
            txtStreet.state.focused = false;
            txtStreet.state.disabled = false;
        }

        txtDate.state.date = moment().startOf('day').add(1, 'day');
        txtDate.state.todaysDate = moment().startOf('day').add(1, 'day');
        txtDate.state.focused = true;
    } catch (err) {
        console.error(err);
        ui.state.isLoading = false;
    }
};

const findPostalCode = async (zip, fromCNP = false) => {
    if (ddlPostcode) {
        ddlPostcode.state.valid = true;
        ddlPostcode.state.list = [];
    }

    //let zip = value;
    if (!zip) return;
    if (!zip || zip.length < 3) return;

    try {
        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/address/${zip}?requestId=${ui.state.flowId}`, {});
        let json;
        if (response.ok)
            json = await response.json();

        state.postalCodeResponse = null;
        if (json && json.length > 0)
            state.postalCodeResponse = json;

        ddlPostcode.state.list = json.map(entry => {
            return {
                key: entry.postCode,
                value: (entry.street ? entry.street + '\n' : '') + (entry.cityCode == '1638' ? entry.cityName : entry.cityName + ', ' + entry.countyName) + ' (' + entry.postCode + ')',
                label: entry.street
            };
        });

        if (state.postalCodeResponse) {
            state.cityCode = getField(state.postalCodeResponse[0], 'cityCode');
            state.cityName = getField(state.postalCodeResponse[0], 'cityName');
            state.county = getField(state.postalCodeResponse[0], 'countyCode');
            state.countyName = getField(state.postalCodeResponse[0], 'countyName');
            state.district = getField(state.postalCodeResponse[0], 'districtCode');
            state.street = getField(state.postalCodeResponse[0], 'streetClean');
            if (state.cityCode && state.cityName && state.county && state.countyName) {
                ddlPostcode.state.selected = zip;
                ddlPostcode.state.disabled = false;
                ddlPostcode.state.focused = true;
            }
            txtCity.state.focused = state.cityName ? true : false;
            txtCity.state.disabled = state.cityName ? true : false;
            txtStreet.state.focused = state.street ? true : false;
            txtStreet.state.disabled = state.street ? true : false;
        }

        if (fromCNP) {
            if (json && json.length > 1) {
                ddlPostcode.state.disabled = false;
                ddlPostcode.state.focused = false;
                state.cityCode = null;
                state.cityName = null;
                state.county = null;
                state.countyName = null;
                state.district = null;
            }
            if (json && json.length === 1) {
                ddlPostcode.state.disabled = false;
                ddlPostcode.state.focused = true;
            }
        }

        if (!fromCNP) ddlPostcode.state.selected = null;
    }
    catch (err) {}
};

//functions
const findCNPCUI = async (cnp) => {
    txtCnp.state.valid = true;
    
    if (!cnp) return;

    const validCUI = validateCUI(cnp);
    state.isCompany = validCUI;
    if (!validCUI) {
        txtCnp.state.valid = false;
        return;
    }

    txtCnp.state.valid = true;

    state.inProgress = true;
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        await new Promise(resolve => setTimeout(resolve, 600));
        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/v2/partner/${cnp}?requestId=${ui.state.flowId}`, {});
        let json;
        if (response.ok)
            json = await response.json();

        if (!json) {
            state.personalInformation = null;

            state.inProgress = false;
            ui.state.isLoading = false;
            return;
        }

        if (json.PostalCode && json.PostalCode.length > 0) {
            state.postalCode = json.PostalCode;
            await findPostalCode(state.postalCode, true);
        } else {
            await findPostalCode('010');
            state.cityName = null;
            state.street = null;
            ddlPostcode.state.focused = false;
            txtCity.state.focused = false;
            txtCity.state.disabled = false;
            txtStreet.state.focused = false;
            txtStreet.state.disabled = false;
        }

        //NOTE!!!! The response returns only the PostalCode, the code below is useless, even the next 'NOTE:'
        //NOTE: the service changed and now returns uppercase properties
        //this is to keep compatibility with the live server
        if (json.CountyId)
            json.countyId = json.CountyId;
        if (json.CityId)
            json.cityId = json.CityId;
        if (json.District)
            json.district = json.District;
        if (json.Id)
            json.id = json.Id;
        if (json.Name)
            json.name = json.Name;

        if (!json.id || json.id === '0') {
            state.personalInformation = null;

            state.inProgress = false;
            ui.state.isLoading = false;
            return;
        }

        state.personalInformation = json;

        if (json.countyId) {
            if (json.countyId === '4') {//Bucuresti
                state.county = '4';
                state.city = '1638';
                txtCity.state.visible = false;
                ddlDistrict.state.visible = true;
                ddlDistrict.state.focused = true;
                if (json.district) {
                    let district = parseInt(json.district);
                    if (district <= 6 && district >= 1) {
                        state.district = district;
                    }
                }
            } else {
                state.county = json.countyId;
                txtCity.state.visible = true;
                txtCity.state.focused = true;
                ddlDistrict.state.visible = false;
                if (json.cityId)
                    state.city = json.cityId;
            }
            if (json.name) state.name = json.name;
        }

        try {
            let lastPolicyResponse = await fetch(`${process.env.API_URL}/api/rcapolicy/v2/lastpolicy?requestId=${ui.state.flowId}`, {
                method: 'POST',
                body: JSON.stringify({
                    id: cnp,
                    vin: vehicleState.vin
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (lastPolicyResponse.ok) {
                let lastPolicy = await lastPolicyResponse.json();
                //{"startDate":["0001-01-01T00:00:00"],"endDate":["0001-01-01T00:00:00"]}
                if (lastPolicy.endDate && lastPolicy.endDate.length > 0) {
                    let endDate = moment(lastPolicy.endDate[0]);
                    if (endDate.isAfter(moment())) {
                        txtDate.state.date = moment(endDate).startOf('day').add(1, 'day');
                        txtDate.state.focused = true;
                        txtDate.state.todaysDate = moment(endDate).startOf('day').add(1, 'day');
                    }
                    else{
                        txtDate.state.date = moment().startOf('day').add(1, 'day');
                        txtDate.state.focused = true;
                        txtDate.state.todaysDate = moment().startOf('day').add(1, 'day');
                    }
                }
            }
        } catch (err) {
            console.error('could not get last policy');
        }

        state.inProgress = false;
        ui.state.isLoading = false;
    }
    catch (err) {
        state.personalInformation = null;
        state.inProgress = false;
        ui.state.isLoading = false;
    }
};

const validateCUI = cui => {
    let cif = cui;
    if (isNaN(parseFloat(cui)) || !isFinite(cui)) {
        cif = cif.toUpperCase();
        if (cif.indexOf('RO') === 0)
            cif = cif.replace('RO', '');
        else
            return false;
        cif = parseInt(cif.trim());
    } else {
        cif = parseInt(cif);
    }
    if (cif.toString().length > 10 || cif.toString().length < 6) {
        return false;
    }
    let v = 753217532;
    let c1 = parseInt(cif % 10);
    cif = parseInt(cif / 10);
    let t = 0;
    while (cif > 0) {
        t += (cif % 10) * (v % 10);
        cif = parseInt(cif / 10);
        v = parseInt(v / 10);
    }
    let c2 = parseInt((t * 10) % 11);
    if (c2 == 10)
        c2 = 0;

    return c1 === c2;
};

//controls
let txtCnp = useDisableSpace(useValidation(useFocus(DOM.txtInsuredCNP)));
let ddlPostcode = useDropdown(DOM.ddlPostcode, {
    onChange: async (v, text) => {

        let entry = state.postalCodeResponse.find((entry) => {
            if (text) return entry.street == text && entry.postCode == v;
            else return entry.postCode == v;
        });

        if (entry) {
            state.postalCode = v;
            state.cityCode = getField(entry, "cityCode");
            state.cityName = getField(entry, "cityName");
            state.county = getField(entry, "countyCode");
            state.countyName = getField(entry, "countyName");
            state.district = getField(entry, "districtCode");
            state.street = getField(entry, "streetClean");
            state.streetType = getField(entry, "streetType");
            txtCity.state.focused = state.cityName ? true : false;
            txtCity.state.disabled = state.cityName ? true : false;
            txtStreet.state.focused = state.street ? true : false;
            txtStreet.state.disabled = state.street ? true : false;
        }
    },
    onSearchChange: async v => {
        findPostalCode(v);
    }
});
let txtCity = useDisabled(useValidation(useVisibility(useFocus(DOM.txtInsuredCity))));
txtCity.state.visible = true;
let txtStreet = useDisabled(useValidation(useVisibility(useFocus(DOM.txtInsuredStreetAddress))));
txtStreet.state.visible = true;
let ddlDistrict = useValidation(useVisibility(useFocus(DOM.ddlInsuredDistrict)));
export let txtDate = useCalendar(useValidation(DOM.txtInsuredDate));
txtDate.state.bind('date', value => {
    state.date = value;
});
useTooltip(DOM.btnInsuredCNPTooltip);
useKeys(DOM.btnInsuredBack);
useKeys(DOM.btnInsuredNext);

//bindings
state.bind('inProgress', value => {
    // DOM.btnInsuredCNPTooltip.classList[value ? 'add' : 'remove']('icon-pause-circle');
    // DOM.btnInsuredCNPTooltip.classList[value ? 'remove' : 'add']('icon-info');

    DOM.txtInsuredCNP.disabled = value;
    DOM.ddlPostcode.disabled = value;
    DOM.ddlInsuredDistrict.disabled = value;
});
state.bind('cnp', DOM.txtInsuredCNP);
state.bind('cityName', DOM.txtInsuredCity);
state.bind('street', DOM.txtInsuredStreetAddress);
state.bind('district', DOM.ddlInsuredDistrict);

//events
DOM.txtInsuredCNP.addEventListener('change', async e => {
    let value = e.target.value;
    await findCNPCUI(value);
});
DOM.txtInsuredCNP.addEventListener('keydown', async e => {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 13) //enter
        findCNPCUI(e.target.value);
});
DOM.btnInsuredBack.addEventListener('click', () => {
    ui.state.slide = [1, 1];
});

DOM.btnInsuredNext.addEventListener('click', async e => {
    e.preventDefault();

    if (state.inProgress)
        return;

    txtCnp.state.valid = true;
    txtCity.state.valid = true;
    ddlDistrict.state.valid = true;
    txtDate.state.valid = true;

    let isValid = true;
    let validCUI = validateCUI(state.cnp);
    state.isCompany = validCUI;
    if (!state.cnp || !validCUI) {
        txtCnp.state.valid = false;
        isValid = false;
    }
    if (!state.postalCode) {
        ddlPostcode.state.valid = false;
        isValid = false;
    }
    if (!state.cityName) {
        txtCity.state.valid = false;
        isValid = false;
    }
    if(!state.street) {
        txtStreet.state.valid = false;
        isValid = false;
    }
    if (state.county && state.county === '4' && (!state.district || state.district === '-1')) {
        ddlDistrict.state.valid = false;
        isValid = false;
    }
    if (!state.date || !state.date.isValid()) {
        txtDate.state.valid = false;
        isValid = false;
    } else if (state.date.isBefore(txtDate.state.todaysDate) ||
        state.date.isAfter(moment().startOf('day').add(60, 'day'))) {
        ui.notyf.error('Te rugăm ca data de început să fie în urmatoarele 60 de zile');
        txtDate.state.valid = false;
        isValid = false;
    }

    if (!isValid)
        return;

    await offer.init();
});

module.exports.state = state;
module.exports.DOM = DOM;

